import styles from './VStack.module.scss';

interface VStackProps {
  gap?: number;
  children: React.ReactNode[] | React.ReactNode;
}

export const VStack = ({ children, gap = 0 }: VStackProps) => (
  <div
    className={styles.vStack}
    style={gap ? ({ '--vstack-gap': `${gap / 16}rem` } as React.CSSProperties) : undefined}
  >
    {children}
  </div>
);
